import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '../../../components/modal/modal.component';
import {StyledFooter} from '../../../components/pane/pane.style';
import Form from '../../../components/form'
import {useForm} from 'react-hook-form';
import {StyledModalContent} from '../../../components/modal/modal.style';
import {StyledButton, StyledWiteButton} from "../../../components/button/button.style";
import {disableSwipeToClose} from "../../../utils/tools/modals";
import {LogisticContainer, Order} from "@app/reportPage/reportPage.component";
import {Preferences} from "@capacitor/preferences";

type SaveConfirmationModalProps = {
    isOpen: boolean;
    logisticContainer: LogisticContainer | null | undefined;
    order: Order;
    onConfirm: () => void;
    onCancel: () => void;
};

type ConfirmationModalInfoDataProps = {
    firstName: string;
    lastName: string;
    companyName: string;
}

const SaveConfirmationModal: React.FC<SaveConfirmationModalProps> = (props: SaveConfirmationModalProps) => {
    const {t} = useTranslation();
    const {handleSubmit} = useForm({
        mode: 'onChange'
    });

    const [showModal, updateShowModal] = useState<boolean>(false);
    const [confirmationModalInfoData, setConfirmationModalInfoData] = useState<ConfirmationModalInfoDataProps>();

    useEffect(() => {
        handleOpen();
    }, [props.isOpen]);

    useEffect(() => {
        handleConfirmationModalInfoData();
    }, [props.order]);

    useEffect(() => {
        const backButtonHandler = (ev: CustomEvent) => {
            if (props.isOpen) {
                ev.detail.register(999, () => {});
            }
        };

        document.addEventListener('ionBackButton', backButtonHandler as EventListener);

        return () => document.removeEventListener('ionBackButton', backButtonHandler as EventListener);
    }, [props.isOpen]);

    const handleConfirmationModalInfoData = async () => {
        const userFirstname = await Preferences.get({'key': 'first_name'});
        const userLastname = await Preferences.get({'key': 'last_name'});

        if (userFirstname.value && userLastname.value) {
            setConfirmationModalInfoData({
                firstName: userFirstname.value,
                lastName: userLastname.value,
                companyName: props.order.place_of_service.name,
            })
        }
    }

    const handleCancel = () => {
        updateShowModal(false);
        props.onCancel();
    };

    const handleSign = () => {
        updateShowModal(false);
        props.onConfirm();
    };

    const handleOpen = () => {
        updateShowModal(props.isOpen);
    };

    return (
        <Modal
            isOpen={showModal}
            canDismiss={disableSwipeToClose}
            disableClose={true}
            onDidDismiss={() => {}}>
            <Form.Container className="modalForm" onSubmit={handleSubmit(handleSign)}>
                <StyledModalContent>
                    <h1 className="title">{t("reportConfirmation.title")}</h1>
                    <div className="content">
                        {props.logisticContainer &&
                            <p>
                                {t("reportConfirmation.descriptionLogisticContainer", {
                                    firstName: confirmationModalInfoData?.firstName,
                                    lastName: confirmationModalInfoData?.lastName,
                                    companyName: confirmationModalInfoData?.companyName
                                })}
                            </p>
                        }
                        {!props.logisticContainer && !props.order.is_enabled_data_accuracy_statement &&
                            <p>
                                {t("reportConfirmation.description")}
                            </p>
                        }
                        {!props.logisticContainer && props.order.is_enabled_data_accuracy_statement &&
                            <p>
                                {t("reportConfirmation.dataAccuracyStatement", {
                                    firstName: confirmationModalInfoData?.firstName,
                                    lastName: confirmationModalInfoData?.lastName,
                                    companyName: confirmationModalInfoData?.companyName
                                })}
                            </p>
                        }
                    </div>
                    <StyledFooter className="modal footer no-shadow">
                        <StyledWiteButton type="button" onClick={handleCancel}>{t("reportConfirmation.cancel")}</StyledWiteButton>
                        <StyledButton type="submit">{t("reportConfirmation.confirm")}</StyledButton>
                    </StyledFooter>
                </StyledModalContent>
            </Form.Container>
        </Modal>
    );
};

export default SaveConfirmationModal;